export const userRights = {
  computed: {
    isDoctor() {
      return this.$store.getters.HAS_DOCTOR
    },
    isNeuroAdmin() {
      return this.$store.getters.HAS_NEURO_ADMIN
    },
    isHospitalAdmin() {
      return this.$store.getters.HAS_HOSPITAL_ADMIN
    },
    isAnyAdmin() {
      return this.isNeuroAdmin || this.isHospitalAdmin
    },
    isReadonly() {
      return this.$store.getters.HAS_READONLY
    },
    isManageAnyCourse() {
      return (this.isDoctor || this.isHospitalAdmin) && !this.isNeuroAdmin
    },
    isManageCourse() {
      return this.isCourseCreator
    },
    isCourseCreator() {
      if (!this.course || !this.course.doctor_id) {
        return false
      }
      if (this.isDoctor) {
        return this.$store.getters.IS_HIMSELF(this.course.doctor_id)
      }
      return false
    },
    isManagePatients() {
      return this.isDoctor || this.isHospitalAdmin
    },
    isNeuroAdminManage() {
      return this.isNeuroAdmin && !this.$store.getters.IS_SELECTED_HOSPITAL
    },
    isOnlyDoctor() {
      return !this.isAnyAdmin && this.isDoctor
    }
  }
}
